import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Award, Landmark, Mail, Send, X } from "lucide-react";

const BORGHI_FARO = [
  { name: "Civitella del Tronto", slug: "civitella-del-tronto" },
  { name: "Assisi", slug: "assisi" },
  { name: "Castelli", slug: "castelli" },
  { name: "Montorio al Vomano", slug: "montorio-al-vomano" },
  { name: "Offida", slug: "offida" },
];

export default function AmbasciatoreFab() {
  const [open, setOpen] = useState(false);
  const [sezione, setSezione] = useState(null);
  const [msg, setMsg] = useState({ nome: "", testo: "" });
  const navigate = useNavigate();

  const inviaAmbasciata = (e) => {
    e.preventDefault();
    if (!msg.testo.trim()) return;
    const subject = encodeURIComponent(`Contatto Ambasciatore 6amico${msg.nome ? ` — ${msg.nome}` : ""}`);
    const body = encodeURIComponent(`${msg.nome ? `Da: ${msg.nome}\n\n` : ""}${msg.testo.trim()}`);
    window.location.href = `mailto:info@6amico.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="fixed bottom-4 right-4 md:bottom-5 md:right-5 z-[60]" data-testid="ambasciatore-fab">
      {open && (
        <div
          role="dialog"
          aria-modal="false"
          aria-label="L'Ambasciatore di 6amico"
          className="mb-3 w-[calc(100vw-2rem)] max-w-[340px] rounded-2xl border border-[#eedfcb] bg-[#fdfbf7] shadow-2xl overflow-hidden"
        >
          <div className="flex items-center justify-between px-4 py-3 bg-stone-900">
            <p className="font-serif font-bold text-white text-sm">
              L&apos;Ambasciatore di 6amico
            </p>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="min-h-[44px] min-w-[44px] -mr-2 flex items-center justify-center text-white/80 hover:text-white"
              aria-label="Chiudi Ambasciatore"
            >
              <X size={18} />
            </button>
          </div>

          <div className="p-4">
            <p className="text-sm font-sans text-stone-800 leading-relaxed">
              Benvenuto su 6amico. Sono l&apos;Ambasciatore del Territorio.
              Posso aiutarti a scoprire borghi nascosti, sentieri, o metterti in
              contatto diretto con la nostra rete civica.
            </p>

            <div className="mt-4 space-y-2">
              <button
                type="button"
                onClick={() => setSezione(sezione === "borghi" ? null : "borghi")}
                aria-expanded={sezione === "borghi"}
                className="w-full min-h-[48px] flex items-center gap-3 px-4 rounded-xl border border-[#eedfcb] bg-white text-left text-sm font-sans font-semibold text-stone-900 hover:border-[#c26d4a] transition-colors"
                data-testid="amb-borghi"
              >
                <Landmark size={17} className="text-[#a85837] shrink-0" aria-hidden />
                Scopri i Borghi-Faro &amp; Sentieri
              </button>
              {sezione === "borghi" && (
                <div className="pl-4 pb-1 flex flex-col gap-1">
                  {BORGHI_FARO.map((b) => (
                    <Link
                      key={b.slug}
                      to={`/comune/${b.slug}`}
                      onClick={() => setOpen(false)}
                      className="min-h-[44px] flex items-center px-3 rounded-lg text-sm font-sans text-stone-800 hover:bg-[#f7efe6] hover:text-[#a85837]"
                    >
                      {b.name}
                    </Link>
                  ))}
                  <Link
                    to="/esplora-la-mappa"
                    onClick={() => setOpen(false)}
                    className="min-h-[44px] flex items-center px-3 rounded-lg text-sm font-sans font-semibold text-[#a85837] hover:bg-[#f7efe6]"
                  >
                    → Esplora la Mappa 3D
                  </Link>
                </div>
              )}

              <button
                type="button"
                onClick={() => navigate("/ambasciatore")}
                className="w-full min-h-[48px] flex items-center gap-3 px-4 rounded-xl border border-[#eedfcb] bg-white text-left text-sm font-sans font-semibold text-stone-900 hover:border-[#c26d4a] transition-colors"
                data-testid="amb-candidati"
              >
                <Award size={17} className="text-[#a85837] shrink-0" aria-hidden />
                Diventa Ambasciatore o Creator del tuo Borgo
              </button>

              <button
                type="button"
                onClick={() => setSezione(sezione === "scrivi" ? null : "scrivi")}
                aria-expanded={sezione === "scrivi"}
                className="w-full min-h-[48px] flex items-center gap-3 px-4 rounded-xl border border-[#eedfcb] bg-white text-left text-sm font-sans font-semibold text-stone-900 hover:border-[#c26d4a] transition-colors"
                data-testid="amb-scrivi"
              >
                <Mail size={17} className="text-[#a85837] shrink-0" aria-hidden />
                Scrivi all&apos;Ambasciata di 6amico
              </button>
              {sezione === "scrivi" && (
                <form onSubmit={inviaAmbasciata} className="pl-4 pb-1 space-y-2">
                  <input
                    type="text"
                    value={msg.nome}
                    onChange={(e) => setMsg({ ...msg, nome: e.target.value })}
                    placeholder="Il tuo nome (facoltativo)"
                    aria-label="Il tuo nome"
                    className="w-full min-h-[44px] rounded-lg border border-[#eedfcb] bg-white px-3 text-sm text-stone-950"
                  />
                  <textarea
                    value={msg.testo}
                    onChange={(e) => setMsg({ ...msg, testo: e.target.value })}
                    placeholder="La tua richiesta all'Ambasciatore…"
                    aria-label="Messaggio per l'Ambasciatore"
                    rows={3}
                    required
                    className="w-full rounded-lg border border-[#eedfcb] bg-white px-3 py-2 text-sm text-stone-950"
                  />
                  <button
                    type="submit"
                    className="w-full min-h-[48px] rounded-full bg-[#162d4a] hover:bg-[#0f1f33] text-white text-sm font-sans font-semibold shadow-md inline-flex items-center justify-center gap-2 transition-colors"
                    data-testid="amb-scrivi-invia"
                  >
                    <Send size={15} aria-hidden />
                    Invia a info@6amico.com
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label="Apri l'Ambasciatore di 6amico"
        className="ml-auto flex items-center gap-2.5 min-h-[56px] pl-2 pr-4 rounded-full bg-[#162d4a] hover:bg-[#0f1f33] text-white shadow-xl border-2 border-[#b8860b]/60 transition-colors"
        data-testid="ambasciatore-toggle"
      >
        <span
          className="w-10 h-10 rounded-full bg-white/15 border border-white/40 font-serif font-bold text-sm flex items-center justify-center"
          aria-hidden
        >
          6a
        </span>
        <span className="hidden sm:inline font-sans text-xs font-bold leading-tight text-left">
          Parla con<br />l&apos;Ambasciatore
        </span>
      </button>
    </div>
  );
}
